import React from 'react';
import { connect } from 'react-redux';

import Provider from 'xgimi-ui/Provider';
import Dialog from 'xgimi-ui/Dialog';
import Toast from 'xgimi-ui/Toast';

import { deviceLogin, login } from '@xgimi-private/user-center';
import StoreComponent, { mapStateToProps } from '@/appComponents/Store';
// import monitor from '@/utils/monitor';
import { getEnvValue } from '@/appUtils/env';

import '@/styles/base.scss';
import s from './.module.scss';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const sensors = require('sa-sdk-javascript');

export interface BaseLayoutProps {
  // 是否显示头部
  isShowHeader?: boolean;
  // 是否显示底部
  isShowFooter?: boolean;
}

interface State {
  // 可视高度
  visualHeight: number;
}

class Component extends StoreComponent<BaseLayoutProps, State> {
  static defaultProps: BaseLayoutProps = {
    isShowHeader: true,
    isShowFooter: true,
  };

  state: State = {
    visualHeight: window.innerHeight,
  };

  // 头部高度
  private headerHeight: number = 0;

  constructor(props: BaseLayoutProps) {
    super(props, { languageKey: 'layout.base' });

    // 初始化文档标题为空
    document.title = '\u200E';

    window.addEventListener('resize', this.onWindowResize);

    // --- 接入神策 ---
    sensors.init({
      server_url: getEnvValue('REACT_APP_SENSORS_SERVER'),
      heatmap: {
        // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'default',
        // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'not_collect',
      },
      show_log: false,
    });
    sensors.registerPage({ $url: window.location.href });
    sensors.quick('autoTrack');

    // --- 监听登录状态 ---
    this.watch('userInfo', () => this.storeState.userCenter.userInfo, (userInfo, oldUserInfo) => {
      // 登录成功
      if (userInfo) {
        // 神策用户登录
        sensors.login(userInfo.uid);
        // 阿里云监控设置用户id
        // monitor.setConfig({
        //   uid: userInfo.uid,
        //   setUsername: () => `${userInfo.nickName}(${userInfo.mobile})`,
        // });
      }
      else if (oldUserInfo) {
        // 神策用户注销
        sensors.logout();
      }
    });

    // --- 监听关闭 ---
    window.addEventListener('pagehide', () => {
      // 神策用户注销
      sensors.logout();
    });

    // --- 用户登录(获取用户信息) --- (成功后会写入storeState.userCenter.userInfo)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    login().catch((data: Record<string, any>) => {
      // console.log(data);
    });

    // --- 设备登录
    deviceLogin();
  }

  componentDidMount() {
    // --- 监听设备信息 ---
    this.watch('deviceInfo', () => this.storeState.userCenter.deviceInfo, (deviceInfo) => {
      if (deviceInfo) {
        // 神策用户登录
        sensors.login(deviceInfo.deviceId);
      }
    }, { isInit: true });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener('resize', this.onWindowResize);
  }

  private onWindowResize = () => {
    this.setState({ visualHeight: window.innerHeight });
  };

  render() {
    return (
      <Provider
        theme={this.storeState.common.theme}
        snackbarProviderProps={{
          ref: this.storeState.common.message,
          className: s.snackbar,
          anchorOrigin: { vertical: 'bottom', horizontal: this.isMobile ? 'center' : 'right' },
          autoHideDuration: 2000,
          maxSnack: 1,
        }}
      >
        {/* 对话框 */}
        <Dialog ref={this.storeState.common.dialog}/>

        {/* Toast */}
        <Toast className={s.toast} classes={{ content: s.toastContent }} ref={this.storeState.common.toast} showTime={2000} />

        {/* 主体 */}
        <div
          className={s.body}
          style={{ minHeight: this.state.visualHeight }}
        >
          {/* 页面 */}
          <div className={s.page}>
            {this.props.children}
          </div>
        </div>
      </Provider>
    );
  }
}

export default connect(mapStateToProps)(Component);
